import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

function getPresenceUrl(): string | null {
  const baseUrl = process.env.REACT_APP_NEST_API;
  if (!baseUrl) return null;
  return `${baseUrl}/consult-presence`;
}

function getPresenceToken(): string | null {
  const token = process.env.REACT_APP_NEST_API_TOKEN;
  if (!token) return null;
  return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
}

export function getConsultPresenceSocket(): Socket | null {
  return socket;
}

export function connectConsultPresenceSocket(): Socket | null {
  const url = getPresenceUrl();
  const token = getPresenceToken();

  if (!url || !token) {
    console.warn('[consult-presence] REACT_APP_NEST_API ou REACT_APP_NEST_API_TOKEN não configurados');
    return null;
  }

  if (socket?.connected) {
    return socket;
  }

  if (socket) {
    socket.connect();
    return socket;
  }

  socket = io(url, {
    auth: { token },
    transports: ['websocket'],
  });

  return socket;
}

export function disconnectConsultPresenceSocket(): void {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
}
